export function logFormDataValues(formData) {
    for(var pair of formData.entries()) {
        console.log(pair[0]+ ', '+ pair[1]);
    }
}